// Erkennt iOS und ob die Seite schon als eigenstaendige App laeuft
// (Projektplan 10.2: iOS zeigt vor der Installation keinen eigenen Prompt).

export function istIOS(): boolean {
  const ua = navigator.userAgent;
  const klassischesIOS = /iPad|iPhone|iPod/.test(ua);
  // iPadOS 13+ meldet sich als "Macintosh", verraet sich aber durch Touch.
  const iPadOS13Plus = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return klassischesIOS || iPadOS13Plus;
}

export function istEigenstaendig(): boolean {
  const iosEigenschaft = (navigator as Navigator & { standalone?: boolean }).standalone;
  return window.matchMedia("(display-mode: standalone)").matches || iosEigenschaft === true;
}
